import HeadingBlock from './base/heading-block';
export default HeadingBlock.extend({
  type: 'heading',
  tagName: 'h1'
});